const cstmQty = document.querySelectorAll(".cstm-qty-selector");
const cstmPlus = document.querySelectorAll("[name='plus']");
const cstmMinus = document.querySelectorAll("[name='minus']");

validation();

cstmPlus.forEach(function(plus){
  plus.addEventListener('click', function(e) {
    e.preventDefault();
    var val = plus.closest(".cstm-qty-selector").querySelector("input").value;
    var max = parseInt(plus.closest(".cstm-qty-selector").querySelector("input").getAttribute('data-max'));
    val = parseInt(val) + 1;
    if(val < max)
    {
      plus.closest(".cstm-qty-selector").querySelector("input").value = val;
    }
    else
    {
      plus.closest(".cstm-qty-selector").querySelector("input").value = max;
      val = max;
    }
    plus.disabled = val == max;
    plus.parentElement.querySelector("[name='minus']").disabled = false;
    const optnVal = plus.closest(".variant-picker__input").querySelector(".prod__option");

    if(optnVal.querySelector(".variant-picker__option[data-value='"+val+"']").length != 0)
    {
      optnVal.querySelector(".variant-picker__option[data-value='"+val+"'] input").click();
    }
    validation();
  });
})


cstmMinus.forEach(function(minus){
  // setDisabledMin(minus);

  minus.addEventListener('click', function(e) {
    e.preventDefault();
    var val = minus.closest(".cstm-qty-selector").querySelector("input").value;
    var min = parseInt(minus.closest(".cstm-qty-selector").querySelector("input").getAttribute('data-min'));
    val = parseInt(val) - 1;
    if(val >= min)
    {
      minus.closest(".cstm-qty-selector").querySelector("input").value = val;
    }
    else
    {
      minus.closest(".cstm-qty-selector").querySelector("input").value = min;
      val = min;
    }
    minus.disabled = val == min;
    minus.parentElement.querySelector("[name='plus']").disabled = false;
    const optnVal = minus.closest(".variant-picker__input").querySelector(".prod__option");

    if(optnVal.querySelector(".variant-picker__option[data-value='"+val+"']").length != 0)
    {
      optnVal.querySelector(".variant-picker__option[data-value='"+val+"'] input").click();
    }
    validation();
  });
});

function validation(){
  var count = 0;
  if(document.querySelector(".prod_free-gift2") != null)
  {
    cstmQty.forEach(function(qty){
      count = parseInt(count) + parseInt(qty.querySelector(".m-cart-quantity--input").value);
    });
  
    var remain = 4 - parseInt(count);
    
    if(remain > 0)
    {
      if(remain == 1)
      {
        document.querySelector(".gift2-item").innerHTML = "item";
      }
      else
      {
        document.querySelector(".gift2-item").innerHTML = "items";
      }
      document.querySelector(".gift2-count").innerHTML = remain;
      document.querySelector(".gift2-count-main").classList.remove("hidden");
      document.querySelector(".prod_free-gift2").querySelector(".lock-icon").classList.remove("hidden");
      document.querySelector(".prod_free-gift2").querySelector(".tick-icon").classList.add("hidden");
      document.querySelector(".prod_free-gift2").classList.remove("active-free-mat");
    }
    else
    {
      document.querySelector(".gift2-count").innerHTML = 0;
      document.querySelector(".gift2-count-main").classList.add("hidden");
      document.querySelector(".prod_free-gift2").querySelector(".lock-icon").classList.add("hidden");
      document.querySelector(".prod_free-gift2").querySelector(".tick-icon").classList.remove("hidden");
      document.querySelector(".prod_free-gift2").classList.add("active-free-mat");
    }
  }
  
}

if (window.location.pathname === '/pages/lp-symptom-led') {
  function handleQtyCommit(inputEl) {
    if (!inputEl) return;

    let max = parseInt(inputEl.getAttribute('data-max'));
    let min = parseInt(inputEl.getAttribute('data-min'));

    if (isNaN(max)) max = 9999;
    if (isNaN(min)) min = 0;

    let raw = inputEl.value.trim();

    if (raw === '') raw = String(min);

    let val = parseInt(raw, 10);
    if (isNaN(val)) val = min;

    if (val > max) val = max;
    if (val < min) val = min;

    let prev = parseInt(inputEl.dataset.lastValue || inputEl.value, 10);
    if (isNaN(prev)) prev = min;

    inputEl.value = val;
    if (val === prev) return;

    inputEl.dataset.lastValue = String(val);

    const cstmWrapper = inputEl.closest('.cstm-qty-selector');
    if (cstmWrapper) {
      const plusBtn = cstmWrapper.querySelector("[name='plus']");
      const minusBtn = cstmWrapper.querySelector("[name='minus']");

      if (plusBtn) plusBtn.disabled = (val == max);
      if (minusBtn) minusBtn.disabled = (val == min);

      const variantInputWrapper = inputEl.closest(".variant-picker__input");
      if (variantInputWrapper) {
        const optnVal = variantInputWrapper.querySelector(".prod__option");
        if (optnVal) {
          const optionInput = optnVal.querySelector(".variant-picker__option[data-value='"+val+"'] input");
          if (optionInput) optionInput.click();
        }
      }
    }

    validation();
  }

  const qtyInputs = document.querySelectorAll(".cstm-qty-selector .m-cart-quantity--input");

  qtyInputs.forEach((inputEl) => {
      inputEl.removeAttribute('readonly');
      inputEl.dataset.lastValue = inputEl.value;

      inputEl.addEventListener('input', () => {
        const raw = inputEl.value;
        const cleaned = raw.replace(/\D+/g, '');
        if (cleaned !== raw) inputEl.value = cleaned;
      });

      inputEl.addEventListener('change', () => handleQtyCommit(inputEl));
      inputEl.addEventListener('blur', () => handleQtyCommit(inputEl));
  })
}
// const addtocart = document.querySelector(".add-to-cart");

// addtocart.addEventListener('click', function(e) {
//   e.stopPropagation();
//   e.preventDefault();
//   let gift1Target = document.querySelector(".gift1-variant");
//   let gift2Target = document.querySelector(".gift2-variant");
//   let items = [];
//   let vid = addtocart.closest(".main-product-form").querySelector("[name='id']").value;
//   let bundleId = "bundle_"+Math.floor(1000 + Math.random() * 9000);
//   let item = {
//     "id":vid,
//     "quantity":1,
//     "properties":{
//       "_bundleId":bundleId
//     }
//   }
//   items.push(item);
  
//   if(gift1Target.querySelector("[data-target-variant='"+vid+"']") != null)
//   {
//     let gift1 = gift1Target.querySelector("[data-target-variant='"+vid+"']").getAttribute("data-gift-variant");
//     let giftItem1 = {
//       "id":gift1,
//       "quantity":1,
//       "properties":{
//         "_bundleId":bundleId,
//         "_giftProduct":"true"
//       }
//     }
//     items.push(giftItem1);
//   }

//   if(gift2Target.querySelector("[data-target-variant='"+vid+"']") != null && gift2Target.closest(".prod_free-gift2").classList.contains("active-free-mat"))
//   {
//     let gift2 = gift2Target.querySelector("[data-target-variant='"+vid+"']").getAttribute("data-gift-variant");
//     let giftItem2 = {
//       "id":gift2,
//       "quantity":1,
//       "properties":{
//         "_bundleId":bundleId,
//         "_giftProduct":"true"
//       }
//     }
//     items.push(giftItem2);
//   }

//   if(items != '')
//   {
//     addtocart.closest(".product-form").classList.add("adding");
//     fetch(window.Shopify.routes.root + 'cart/add.js', {
//       body: JSON.stringify({ 
//         'items':items,
//         "sections": document.querySelector('m-cart-drawer').getSectionsToRender().map((section) => section.id),
//         "sections_url": window.location.pathname,
//       }),
//       credentials: 'same-origin',
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
//       }
//     }).then(response => {
//       return response.json();
//     }).then(response => {
//        document.querySelector('m-cart-drawer').renderContents(response);
//         document.querySelectorAll('.m-cart-drawer--inner').forEach(function(element) {
//           element.classList.remove('al-loading-bar', 'loading', 'al-loading-overlay', 'overlay-show');
//         });
//         attachEventListeners();
//         addtocart.closest(".product-form").classList.remove("adding");
//     }).catch((error) => {
//       document.querySelector('.m-cart-drawer--inner').classList.remove('al-loading-bar','loading', 'al-loading-overlay', 'overlay-show');
//       addtocart.closest(".product-form").classList.remove("adding");
//       console.error('Error:', error);
//     });
//   }
  
// });

// document.addEventListener('click', function(e) {
//   if (e.target.matches('.m-cart-quantity--button[name="minusBundle"]')) {
//     e.preventDefault();
//     var button = e.target;
//     var qty = button.closest("m-quantity-input-b").querySelector(".m-cart-quantity--input").value;
//     qty = parseInt(qty) - 1;
//     if(qty != 0)
//     {
//       button.closest("m-quantity-input-b").querySelector(".m-cart-quantity--input").value = qty;
//       updateCartBundle(button,qty)
//     }
//   }
//   if (e.target.matches('.m-cart-quantity--button[name="plusBundle"]')) {
//     e.preventDefault();
//     var button = e.target;
//     var qty = button.closest("m-quantity-input-b").querySelector(".m-cart-quantity--input").value;
//     qty = parseInt(qty) + 1;
//     if(qty != 0)
//     {
//       button.closest("m-quantity-input-b").querySelector(".m-cart-quantity--input").value = qty;
//       updateCartBundle(button,qty);
//     }
//   }
//   if (e.target.matches('m-cart-remove-button-b,m-cart-remove-button-b .scd-item__remove')) {
//     e.preventDefault();
//     var button = e.target;
//     var qty = 0;
//     updateCartBundle(button,qty);
//   }
// });

// function updateCartBundle(target,qty){
//   var bundleId = target.closest(".m-cart-drawer--item").getAttribute("data-bundleid");
//   let updateItems = {};
  
  
//   document.querySelectorAll(".m-cart-drawer--item[data-bundleid='"+bundleId+"']").forEach(function(item){
//     var id = item.getAttribute("data-id");
//     updateItems[id] = qty;
//   });

//   if(updateItems != '')
//   {
//     document.querySelector('.m-cart-drawer--inner').classList.add('al-loading-bar','loading', 'al-loading-overlay', 'overlay-show');
//     fetch(window.Shopify.routes.root + 'cart/update.js', {
//       body: JSON.stringify({ 
//         'updates':updateItems,
//         "sections": document.querySelector('m-cart-drawer').getSectionsToRender().map((section) => section.id),
//         "sections_url": window.location.pathname,
//       }),
//       credentials: 'same-origin',
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
//       }
//     }).then(response => {
//       return response.json();
//     }).then(response => {
//        document.querySelector('m-cart-drawer').renderContents(response);
//         document.querySelectorAll('.m-cart-drawer--inner').forEach(function(element) {
//           element.classList.remove('al-loading-bar', 'loading', 'al-loading-overlay', 'overlay-show');
//         });
//         attachEventListeners();
//         addtocart.closest(".product-form").classList.remove("adding");
//     }).catch((error) => {
//       document.querySelector('.m-cart-drawer--inner').classList.remove('al-loading-bar','loading', 'al-loading-overlay', 'overlay-show');
//       addtocart.closest(".product-form").classList.remove("adding");
//       console.error('Error:', error);
//     });
//   }
// }


